import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const PlusStrokeIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
        >
            <path
                className={fillStyles}
                d="M10.834 4.16683C10.834 3.7066 10.4609 3.3335 10.0007 3.3335C9.5404 3.3335 9.16732 3.7066 9.16732 4.16683V9.16683H4.16732C3.70708 9.16683 3.33398 9.53991 3.33398 10.0002C3.33398 10.4604 3.70708 10.8335 4.16732 10.8335H9.16732V15.8335C9.16732 16.2937 9.5404 16.6668 10.0007 16.6668C10.4609 16.6668 10.834 16.2937 10.834 15.8335V10.8335H15.834C16.2942 10.8335 16.6673 10.4604 16.6673 10.0002C16.6673 9.53991 16.2942 9.16683 15.834 9.16683H10.834V4.16683Z"
            />
        </svg>
    );
};
